import {
  ActionTree,
  MutationTree,
  GetterTree,
  Module,
  Commit,
  Dispatch,
} from "vuex";
import { Response } from "@/types/response-type";
import { RootState } from "@/types/root-type";
import { Withholding, WithholdingState } from "@/types/withholding";
import {
  client_withholding_ica_service,
  client_withholding_tax_service,
} from "@/services/withholding-service";

const state: WithholdingState = {
  response: { status: 400, message: "" },
};

const mutations: MutationTree<WithholdingState> = {
  set_response(state: WithholdingState, payload: Response): void {
    state.response = payload;
  },
};

const actions: ActionTree<WithholdingState, RootState> = {
  withholding_tax_action: async (
    { commit, dispatch }: { commit: Commit; dispatch: Dispatch },
    payload: Withholding
  ): Promise<void> => {
    dispatch("update_loading", true, { root: true });
    try {
      const response: Response = await client_withholding_tax_service(payload);
      if (response.status === 200 && response.data instanceof Blob) {
        commit("set_response", {
          status: response.status,
          message: response.message,
        });
        const new_blob = new Blob([response.data], {
          type: "application/pdf;charset-UTF-8",
        });
        const data = window.URL.createObjectURL(new_blob);
        const link = document.createElement("a");
        link.href = data;
        link.download = "ReteFuente.pdf";
        link.click();
        setTimeout(() => window.URL.revokeObjectURL(data), 100);
      } else {
        commit("set_response", {
          status: 400,
          message: response.message,
        });
      }
    } catch (err) {
      const error = err as Error;
      commit("set_response", { status: 400, message: error.message });
    }
    dispatch("update_loading", false, { root: true });
  },
  withholding_ica_action: async (
    { commit, dispatch }: { commit: Commit; dispatch: Dispatch },
    payload: Withholding
  ): Promise<void> => {
    dispatch("update_loading", true, { root: true });
    try {
      const response: Response = await client_withholding_ica_service(payload);
      if (response.status === 200 && response.data instanceof Blob) {
        commit("set_response", {
          status: response.status,
          message: response.message,
        });
        const new_blob = new Blob([response.data], {
          type: "application/pdf;charset-UTF-8",
        });
        const data = window.URL.createObjectURL(new_blob);
        const link = document.createElement("a");
        link.href = data;
        link.download = "ReteIca.pdf";
        link.click();
        setTimeout(() => window.URL.revokeObjectURL(data), 100);
      } else {
        commit("set_response", {
          status: 400,
          message: response.message,
        });
      }
    } catch (err) {
      const error = err as Error;
      commit("set_response", { status: 400, message: error.message });
    }
    dispatch("update_loading", false, { root: true });
  },
};

const getters: GetterTree<WithholdingState, RootState> = {
  response: (state: WithholdingState): Response => state.response,
};

const namespaced = true;

export const withholding_module: Module<WithholdingState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
